import { render, staticRenderFns } from "./BaseMenuIcon.vue?vue&type=template&id=cc64b5e8"
import script from "./BaseMenuIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMenuIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports